import React from 'react';
import PropTypes from 'prop-types';

export const SettingsPageGrid = ({
  children
}) => (
  <div className="ps-container-lg-margin ps-container-fixed settings-container">
    <div className="ps-row settings-row" style={{ height: '100%' }}>
      <div className="col-md-4">
        {children[0]}
      </div>
      <div className="col-md-8">
        {children[1]}
      </div>
    </div>
  </div>
);

SettingsPageGrid.propTypes = {
  children: PropTypes.array
};
